// base
import { createAsyncThunk } from '@reduxjs/toolkit';

// api
import { companyApi } from '../apis/company.api';

// action
import { actions } from '../actions/company.action';

/**
 * company 목록 조회
 */
export const getCompanyList = createAsyncThunk(
  actions.getCompanyAction,
  async (data, { fulfillWithValue, rejectWithValue }) => {
    try {
      const res = await companyApi.getCompany(data);

      const { code, isSuccess, message, resultList, resultObject, totalMap } = res;
      if (!res || !resultList || !resultObject || code !== 200) {
        return fulfillWithValue({
          code,
          isSuccess,
          message,
          resultList,
          resultObject,
          totalMap
        });
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
/**
 * company 이름 목록 조회
 */
export const getCompanyNames = createAsyncThunk(
  actions.getCompanyNameAction,
  async (data, { fulfillWithValue, rejectWithValue }) => {
    try {
      const data = { size: 999 };
      const res = await companyApi.getCompanyNames(data);
      const { code, isSuccess, message, resultList, resultObject, totalMap } = res;
      const result = resultList.map((item) => ({
        ...item,
        label: item.companyName,
        value: item.companyId
      }));

      if (!res || !resultList || !resultObject || code !== 200) {
        return fulfillWithValue({
          code,
          isSuccess,
          message,
          resultList: result,
          resultObject,
          totalMap
        });
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * company 상세조회
 */

export const getCompanyDetail = createAsyncThunk(
  actions.getCompanyDetailAction,
  async (data, { fulfillWithValue, rejectWithValue }) => {
    try {
      const res = await companyApi.getCompanyDetail(data);
      const { code, isSuccess, message, resultList, resultObject, totalMap } = res;

      let image = '';
      if (resultObject?.companyFileId) {
        image = await companyApi.getCompanyPicAPI(resultObject?.companyFileId);
      }

      if (!res || !resultList || !resultObject || code !== 200) {
        return fulfillWithValue({
          code,
          isSuccess,
          message,
          resultList,
          resultObject: { ...resultObject, thumnail: image },
          totalMap
        });
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * company 추가
 */

export const createCompany = createAsyncThunk(
  actions.createCompanyAction,
  async (data, { fulfillWithValue, rejectWithValue }) => {
    try {
      const res = await companyApi.createCompany(data);
      const { code, isSuccess, message, resultList, resultObject, totalMap } = res;

      if (!res || !resultList || !resultObject || code !== 200) {
        return fulfillWithValue({
          code,
          isSuccess,
          message,
          resultList,
          resultObject,
          totalMap
        });
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * company 수정
 */

export const updateCompany = createAsyncThunk(
  actions.updateCompanyAction,
  async (data, { fulfillWithValue, rejectWithValue }) => {
    try {
      const res = await companyApi.updateCompany(data);
      const { code, isSuccess, message, resultList, resultObject, totalMap } = res;

      if (!res || !resultList || !resultObject || code !== 200) {
        return fulfillWithValue({
          code,
          isSuccess,
          message,
          resultList,
          resultObject,
          totalMap
        });
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * company 삭제
 */

export const deleteCompany = createAsyncThunk(
  actions.deleteCompanyAction,
  async (data, { fulfillWithValue, rejectWithValue }) => {
    try {
      const res = await companyApi.deleteCompany(data);
      const { code, isSuccess, message, resultList, resultObject, totalMap } = res;

      if (!res || !resultList || !resultObject || code !== 200) {
        return fulfillWithValue({
          code,
          isSuccess,
          message,
          resultList,
          resultObject,
          totalMap
        });
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
